export default "__VITE_ASSET__4516aa31__"